import React, { useState } from "react";
import { Button, TextField, Box } from "@mui/material";

const sxTextField = {
  m: 0.5,
  width: "100%",
  maxWidth: 400,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: 13,
  },
  "& .MuiInputLabel-root": {
    fontSize: 13,
  },
};

const AddUser = ({ clickAdd }) => {
  const [username, set_username] = useState("");
  const [new_password, set_new_password] = useState("");
  const [new_password_confirmation, set_new_password_confirmation] =
    useState("");

  const canConfirm =
    username !== "" &&
    new_password !== "" &&
    new_password === new_password_confirmation;

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <TextField
        sx={sxTextField}
        size="small"
        id="username"
        label="Username"
        variant="outlined"
        value={username}
        onChange={(e) => set_username(e.target.value)}
      />
      <TextField
        sx={sxTextField}
        size="small"
        id="new_password"
        type="password"
        label="New password"
        variant="outlined"
        value={new_password}
        onChange={(e) => set_new_password(e.target.value)}
      />
      <TextField
        sx={sxTextField}
        size="small"
        id="new_password_confirmation"
        type="password"
        label="Retype new password"
        variant="outlined"
        value={new_password_confirmation}
        onChange={(e) => set_new_password_confirmation(e.target.value)}
      />
      <Button
        disabled={!canConfirm}
        variant="contained"
        disableElevation
        sx={{
          m: 0.5,
          width: "100%",
          maxWidth: 400,
          borderRadius: "20px",
          textTransform: "none",
          fontWeight: 500,
          fontSize: 13,
          mt: 1,
        }}
        onClick={() => {
          clickAdd({ username: username, password: new_password });
        }}
      >
        Confirm Add User
      </Button>
    </Box>
  );
};

export { AddUser };
